import { useQuery } from '@apollo/client'

function usePolling({ query, isEnable, variables, interval, onUpdate }) {
  useQuery(query, {
    variables: variables,
    skip: !isEnable,
    pollInterval: interval,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted: onUpdate
  })
}

export default usePolling
